module.exports = __webpack_public_path__ + "ac6898d178b640cff38cecdd9488948a.png";